import type { Msg } from '../chat'
import type { CreateUniverseCharPayload } from '@/types/universe'
import type { Character, Message, Role } from '@/types'

export function mapToCreateUniverseCharPayload(
  charResponse: Character,
): CreateUniverseCharPayload {
  const payload = {
    charId: charResponse.charId,
    charName: charResponse.charName,
    charDescription: charResponse.charDescription,
    pose: charResponse.pose,
    voice: charResponse.voice,
    language: charResponse.language,
  }
  return payload
}

export function mapMessageToMsg(message: Message): Msg {
  return {
    name: message.name,
    message: message.message,
    role: message.role,
    action: message.action,
    expression: message.expression,
    charOrUserId: message.charOrUserId,
  }
}

/**
 * This is to make sure the role is consistent throughout the app
 * @param role string
 * @returns string
 */
export function validateRole(role: string | null | undefined): Role {
  if (
    role == null
    || role === undefined
    || role === 'character'
    || role.length === 0
  ) {
    return 'char'
  }
  else {
    return role as Role
  }
}
